/**
 * @module LegendSetting/seriesSortByUtils
 * @description 图例系列排序 — 上传 payload 构造
 */

import { SortByEnum, type TSortByEnum } from '../common/SortByPanel/SortType';
import type { ICustomMetricSortValueItem } from '../common/SortByPanel/CustomMetricSort';
import type { ISeriesSortValueItem } from '../../types/settings/sortFields';

export type { ISeriesSortValueItem };

export interface ISeriesSortState {
  seriesSorts: ISeriesSortValueItem[];
  seriesOrder: string[];
  quickDragSeed: string[];
  columnMetrics: unknown[];
}

export function buildDefaultSeriesSortPayload(): Record<string, unknown> {
  return {
    sort_series: SortByEnum.Default,
    series_order: undefined,
    series_sorts: undefined,
  };
}

export function buildMetricSeriesSortPayload(
  seriesSorts: ISeriesSortValueItem[],
): Record<string, unknown> {
  return {
    sort_series: SortByEnum.Metric,
    series_order: undefined,
    series_sorts: seriesSorts,
  };
}

/** 手动排序：优先使用 seriesOrder，否则用计算接口种子 */
export function buildManualSeriesSortPayload(
  seriesOrder: string[],
  quickDragSeed: string[],
): Record<string, unknown> {
  const values = seriesOrder.length > 0 ? seriesOrder : quickDragSeed;
  return {
    sort_series: SortByEnum.Manual,
    series_sorts: undefined,
    series_order: values.length > 0 ? values : undefined,
  };
}

export function buildSortTypeChangePayload(
  mode: TSortByEnum,
  state: ISeriesSortState,
): Record<string, unknown> {
  if (mode === SortByEnum.Default || mode === SortByEnum.DatasetFieldSort) {
    return buildDefaultSeriesSortPayload();
  }

  if (mode === SortByEnum.Metric) {
    let { seriesSorts } = state;
    if (
      (!seriesSorts || seriesSorts.length === 0)
      && Array.isArray(state.columnMetrics)
      && state.columnMetrics.length > 0
    ) {
      const first = state.columnMetrics[0] as Record<string, unknown>;
      seriesSorts = [{
        key: String(first?.column_name || ''),
        value: 'asc',
        table_code: String(first?.table_code || 't0'),
      }];
    }
    return buildMetricSeriesSortPayload(seriesSorts || []);
  }

  const computed = [...state.quickDragSeed];
  return buildManualSeriesSortPayload(computed, state.quickDragSeed);
}
